import React from 'react';
import './SiteIndisponible.css';
import logo from '../assets/logo_pro.jpg';
import { useTranslation } from '../i18n';

// Page affichée à la place du site quand le serveur répond par une erreur 50x (cf. serverStatus.js)
function SiteIndisponible() {
    const { t } = useTranslation();
    return (
        <div className="site_indisponible" role="alert">
            <img className="site_indisponible_logo" src={logo} alt={t('common.logoPro')} />
            <h1>{t('unavailable.title')}</h1>
            <p>{t('unavailable.text')}</p>
            <button type="button" onClick={() => window.location.reload()}>
                {t('unavailable.retry')}
            </button>
        </div>
    );
}

export default SiteIndisponible;
